import ApplicationSerializer from 'eflex/serializers/application';

export default class EdhrProcessDatum extends ApplicationSerializer {
  attrs = {
    buildStatusChild: {
      serialize: false,
      deserialize: false,
    },
  };
}
